import { render } from "./WhatWeDo.vue?vue&type=template&id=6fba4d16&scoped=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import "./WhatWeDo.vue?vue&type=style&index=0&id=6fba4d16&lang=scss"
import "./WhatWeDo.vue?vue&type=style&index=1&id=6fba4d16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fba4d16"]])

export default __exports__